import React from "react"
import Swiper from "swiper"

class UsersVoice extends React.Component {
  componentDidMount() {
    new Swiper(".users-voice .swiper-container", {
      slidesPerView: 1,
    })
  }

  render() {
    return (
      <div className="users-voice">
        <div data-aos="fade-up" className="has-text-centered">
          <h2 className="title is-2 mb-0">USER'S VOICE</h2>
          <small className="has-text-grey-light">お客様の声</small>
        </div>
        <div data-aos="fade-up">
          <div className="swiper-container">
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <div className="background is-1">
                  <div className="voice">
                    <div className="title is-5">
                      PICKSのことは行きつけのレストランに掲載されていたPOPではじめて知りました。お客さんが集中してしまう、ランチタイムの長蛇の列をスキップしてすぐに商品を受け取れるので非常に便利です。いつも利用しています！
                    </div>
                    <div className="text">Y.H.様 40代　男性　会社員</div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="background is-2">
                  <div className="voice">
                    <div className="title is-5">
                      ランチタイムが短いので、時短のためにPicksを活用しています。
                      食べ物の好き嫌いも口頭ではなかなか伝わらないので、テキストでコメントができてとても便利です。
                      ポイントバックキャンペーンなどでお得にテイクアウトできることもあるので、活用しています！
                    </div>
                    <div className="text">M.O様 会社員30代　女性</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default UsersVoice
